import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    flex: 2,
  },
  p24: {
    padding: 24,
  },
  pdmpContainer: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    padding: '20px 24px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  medicationsContainer: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
    width: '100%',
    backgroundColor: 'white',
  },
  header: {
    padding: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  headerSubTitle: {
    color: colors.neutral600,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  body: {
    borderTop: `1px solid ${colors.neutral100}`,
    borderBottom: `1px solid ${colors.neutral100}`,

  },
  medicationBody: {
    display: 'flex',
    gap: 12,
    overflowY: 'auto',
  },
  badgeSuccess: {
    backgroundColor: colors.success100,
    color: colors.success600,
    padding: '2px 10px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.12px',
    borderRadius: '100px',
    textTransform: 'capitalize',
  },
  card: {
    background: colors.white,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 24,
    gap: 8,
    borderBottom: `1px solid ${colors.neutral200}`,
    cursor: 'pointer',
    '&:last-child': {
      borderBottom: 'none',
    }

  },
  cardTitle: {
    fontWeight: 700,
    fontSize: 22,
    lineHeight: '28px',
    letterSpacing: '-0.22px',
  },
  cardSubTitle: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral700,
  },
  detailHr: {
    width: '100%',
    height: '1px',
    backgroundColor: colors.neutral100,
  },
  drugDetailsBox: {
    paddingTop: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
  bodyUuid: {
    fontWeight: 400,
    fontSize: 36,
    lineHeight: '44px',
    color: colors.neutral900,
    fontfamily: 'Source Serif Pro',
  },
  bodyServiceName: {
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
    fontfamily: 'Source Serif Pro',
  },
  codesHeading: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
  },
  codes: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  footer: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  footerText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  footerBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary500,
    maxHeight: '20px',
  },
  inlineLink: {
    textTransform: 'none !important',
    fontWeight: 700,
    lineHeight: '20px',
    color: colors.primary500,
    cursor: 'pointer',
  },
  addBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    width: '100%',
    color: colors.primary500,
    display: 'flex',
    padding: 0,
    gap: 8,
    '& svg': {
      width: 18,
      height: 18,
    },
  },
});
